// After a successful DOB match for a shared phone/email login, keep the
// verified date in sessionStorage so later /my-case calls (and refreshes in
// this tab) skip the modal. Cleared on sign-out. Never use localStorage —
// another person on the same device must not inherit a DOB. An in-memory
// map covers the current tab when sessionStorage throws (private mode /
// quota) so other useMyCase mounts still hear the resolution.

const storageKey = (customerId) => `mycase_dob:${customerId}`;
const isValidDob = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value);

const inMemoryDobs = new Map();

export const DOB_RESOLVED_EVENT = "mycase-dob-resolved";

export const readStoredDob = (customerId) => {
  if (!customerId) return null;
  const inMemoryDob = inMemoryDobs.get(customerId);
  if (inMemoryDob && isValidDob(inMemoryDob)) return inMemoryDob;
  if (typeof sessionStorage === "undefined") return null;
  try {
    const v = sessionStorage.getItem(storageKey(customerId));
    return v && isValidDob(v) ? v : null;
  } catch {
    return null;
  }
};

export const storeDob = (customerId, dateOfBirth) => {
  if (!customerId || !dateOfBirth) return;
  inMemoryDobs.set(customerId, dateOfBirth);
  try {
    sessionStorage.setItem(storageKey(customerId), dateOfBirth);
  } catch {
    // Private mode / quota — in-memory still covers this tab.
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(DOB_RESOLVED_EVENT, {detail: {customerId}}),
    );
  }
};

export const clearStoredDob = (customerId) => {
  if (!customerId) return;
  inMemoryDobs.delete(customerId);
  try {
    sessionStorage.removeItem(storageKey(customerId));
  } catch {
    // ignore
  }
};

export const clearAllStoredDobs = () => {
  inMemoryDobs.clear();
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith("mycase_dob:")) keys.push(k);
    }
    keys.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    // ignore
  }
};
